import React from 'react';

type Awards = {
  name: string;
  year: string;
  category: string;
  type: string;
  score: number;
};

interface AwardsProps {
  collection: Awards[] | null;
}

const Awards = ({collection}: AwardsProps) => {
  let showList: any[] = [];
  let newList: any[] = [];

  if (collection !== null && collection.length > 0) {
    collection.forEach((con: Awards) => {
      newList = showList.concat(
        <li>
          {con.name}, {con.year}, {con.category}, {con.type} <br />
        </li>,
      );
      showList = newList;
    });

    return (
      <p>
        <h4>Awards</h4>
        {showList}
      </p>
    );
  }

  return <p> </p>;
};

export default Awards;
